import React from "react";
import { useLocation, useHistory } from "react-router-dom";
import { Navbar, Container, Nav, Button } from "react-bootstrap";

import routes from "routes.js";
import routesAdmin from "routesAdmin.js";
import { useUser } from "../../contexts/UserContext";

function Header() {
  const location = useLocation();
  const history = useHistory();
  const { user, layout, setLayout, logout } = useUser();

  const mobileSidebarToggle = (e) => {
    e.preventDefault();
    document.documentElement.classList.toggle("nav-open");
    var node = document.createElement("div");
    node.id = "bodyClick";
    node.onclick = function () {
      this.parentElement.removeChild(this);
      document.documentElement.classList.toggle("nav-open");
    };
    document.body.appendChild(node);
  };

  const logOut = async (e) => {
      e.preventDefault();
      await logout();
  }

  const adminDashBoard = () => {
    if(layout == 'Admin'){
        setLayout('Basic');
        history.push('/manage/dashboard');
    }else{
        setLayout('Admin');
        history.push('/admin/resonicadmins');
    }
  }

  const getBrandText = () => {
    for (let i = 0; i < routes.length; i++) {
      if (location.pathname.indexOf(routes[i].layout + routes[i].path) !== -1) {
        return routes[i].name;
      }
    }
    for (let i = 0; i < routesAdmin.length; i++) {
      if (location.pathname.indexOf(routesAdmin[i].layout + routesAdmin[i].path) !== -1) {
        return routesAdmin[i].name;
      }
    }
    return "Brand";
  };
  return (
    <Navbar bg="light" expand="lg">
      <Container fluid>
        <div className="d-flex justify-content-center align-items-center ml-lg-0">
          <Navbar.Toggle aria-controls="basic-navbar-nav" className="mr-2 d-lg-none btn-fill d-flex justify-content-center align-items-center mobile-menu p-12-10">
              <i className="fa fa-fw fa-align-justify"></i>
          </Navbar.Toggle>
          <Navbar.Brand
            id="title-section-id"
            className="mr-2"
          >
            {getBrandText()}
          </Navbar.Brand>
        </div>
        <Button
            variant="dark"
            className="d-lg-none btn-fill d-flex justify-content-center align-items-center mobile-menu p-12-10"
            onClick={mobileSidebarToggle}
        >
            <i className="fa fa-fw fa-angle-left"></i>
        </Button>
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ml-auto" navbar>
            <Nav.Item>
              <Nav.Link
                  className="m-0"
                  href="#"
                  onClick={adminDashBoard}
              >
                  {
                      (user != null && (user.role == "RESONIC_ADMIN")) ? <span className="no-icon">{(layout == 'Admin') ? "Platform basic" : "Platform administration"}</span> : ''
                  }
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link
                className="m-0"
                href="/"
                onClick={logOut}              >
                  <i className="nc-icon nc-button-power pr-2"></i> Log out
              </Nav.Link>
            </Nav.Item>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default Header;
